<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="columnsPublicHoliday"
        :items="emptyItemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="64">
          <v-spacer></v-spacer>
          <PublicHolidayNewEditDialog></PublicHolidayNewEditDialog>
        </v-toolbar>
      </template>
      <template v-slot:item.edit="{ item }">
        <PublicHolidayNewEditDialog :item="item"></PublicHolidayNewEditDialog>
      </template>
      <template v-slot:item.delete="{ item }">
        <PublicHolidayDeleteDialog :item="item"></PublicHolidayDeleteDialog>
      </template>
      <template v-slot:item.dt="{ item }">
        <span v-if="item.dt">
          {{ item.dt | moment("DD.MM.YYYY") }}
        </span>
      </template>
    </v-data-table>
<!--    <TimeTrackerConfirmDialog></TimeTrackerConfirmDialog>-->
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import PublicHolidayNewEditDialog from "@/components/TimeTracker/PublicHolidayNewEditDialog";
import PublicHolidayDeleteDialog from "@/components/TimeTracker/PublicHolidayDeleteDialog";

export default {
  name: 'PublicHoliday',
  props: {
    subtractHeight: {type: [Number], default: 150},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    date: {default: null},
    dto_model: {type: [String], default: 'CalendarDatePublicHolidayDTO'},
    uncheckedInit: {type: [Boolean], default: null},
    deletedInit: {type: [Boolean], default: null},
    errorInit: {type: [Boolean], default: null},
  },

  components: {
    PublicHolidayNewEditDialog,
    PublicHolidayDeleteDialog,
  },

  computed: {
    ...mapGetters('CalendarDate', ['getColumns']),
    ...mapFields('CalendarDate', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'columnsPublicHoliday']),

    emptyItemList() {
      const self = this
      return this.itemList.filter( item => item.public_holiday != null )
    },
  },

  methods: {
    ...mapActions('CalendarDate', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    compareCurrentVsEventStart(item) {
      const currentDate = new Date()
      currentDate.setHours(0)
      currentDate.setMinutes(0)
      currentDate.setSeconds(0)
      currentDate.setMilliseconds(0)
      const event_start = new Date(item.event_start)
      return event_start.getTime() >= currentDate.getTime()
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions')
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
  },

  async mounted() {
    // console.log('mounted')
    this.onUpdateFilters()
  },

  data() {
    return {
      search: null,
      windowSize: {x: 0, y: 0,},
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
